export default {
    'bond-no': 'Número de bono',
    'entry-no': 'Número de asiento',
    'debit': 'Débito',
    'credit': 'Crédito',
    'currency-debit': 'Débito en moneda extranjera',
    'currency-credit': 'Crédito en moneda extranjera',
    'currency-price': 'Precio',
    'balance': 'Saldo',
    'currency': 'Moneda',
    'date': 'Fecha',
    'paper-document-no': 'Ref. Doc.',
    'note': 'Descripción',
    'matching-date': 'Fecha de reconciliación',
}